<template>
  <div>
    <list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <posts :list="list"  />
    </list>
  </div>
</template>

<script>
/**
@description:发布
@createTime:2021-09-01
@create:wq
*/
import posts from "../../../components/posts.vue";
import { List } from "vant";

export default {
  name: "",
  props: {},
  components: { posts, List },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {},
  methods: {
    onLoad() {
      this.getList();
    },
    getList() {
      this.api.myCommunity().then((res) => {
        // console.log(res.data.data);
        this.list = [...this.list, ...res.data.data];
        this.list.map(r => {
          r.allTitle = JSON.parse(JSON.stringify(r.title))
        })
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style scoped></style>
